import {useCallback, useState} from 'react';

const useEditorState = () => {
  const [editorState, setEditorState] = useState();
  const [isEditing, setIsEditing] = useState(false);

  const startEditing = useCallback(() => {
    setIsEditing(true);
  }, []);

  //   const saveEditing = useCallback((content) => {
  //     setEditorState(content);
  //     setIsEditing(false);
  //   }, []);

  const cancelEditing = useCallback(() => {
    setIsEditing(false);
  }, []);

  return {
    editorState,
    isEditing,
    startEditing,
    // saveEditing,
    cancelEditing,
    setEditorState,
  };
};

export default useEditorState;
